import { useContext, useEffect, useState } from 'react'
import chevRght from '../../assets/images/chev-right.svg'
import exclamation from '../../assets/images/exclamation.svg'
import binIcon from '../../assets/images/menu/bin-icon.svg'
import callIcon from '../../assets/images/menu/call-icon.svg'
import chores from "../../assets/images/menu/chores.svg"
import contribution from "../../assets/images/menu/contribution.svg"
import dollorIcon from '../../assets/images/menu/dollar-icon.svg'
import editIcon from "../../assets/images/menu/edit-icon.svg"
import expense from "../../assets/images/menu/expense.svg"
import logout from "../../assets/images/menu/logout.svg"
import newPasswordIcon from "../../assets/images/menu/new-password-icon.svg"
import notification from "../../assets/images/menu/notification.svg"
import opportunityCost from "../../assets/images/menu/opportunity-cost.svg"
import questionIcon from '../../assets/images/menu/question-icon.svg'
import report from "../../assets/images/menu/report.svg"
import shieldIcon from '../../assets/images/menu/shield-icon.svg'
import usersIcon from "../../assets/images/menu/users-icon.svg"


import toast from 'react-hot-toast'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import { Link, useNavigate } from 'react-router-dom'
import fileIcon from '../../assets/images/file-icon.svg'
import payment from '../../assets/images/menu/payment.svg'
import CustomModal from '../../components/layouts/CustomModal'
import Logout from '../../components/layouts/Logout'
import ProfileImage from '../../components/layouts/ProfileImage'
import Button from '../../components/ui/Button'
import PageLayout from '../../components/ui/PageLayout'
import { ApiConstants } from '../../constants/ApiConstants'
import { ApiTypes, PERMISSIONS, USER_ROLE_TYPES } from '../../constants/Constants'
import { Routes } from '../../constants/RouteConstants'
import authContext from '../../context/authContext'
import useMakeRequest from '../../utils/ApiHelper'
import { checkPermission, getMemberType, getPricingType, handleLogout, hasAnySubscription } from '../../utils/Helper';
import UpgradeToast from '../../components/layouts/UpgradeToast'

const Profile = () => {

  const myProfile: any = useContext(authContext);
  let profile: any = useContext(authContext);
  console.log("profile: ", profile)
  const deleteAccount = useMakeRequest();
  const hhMembers = useMakeRequest();
  const leaveHousue = useMakeRequest();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [visibleDeleteAccount, setVisibleDeleteAccount] = useState(false);
  const [visibleLeaveHH, setVisibleLeaveHH] = useState(false);
  const [expandedSections, setExpandedSections] = useState<{ [key: string]: boolean }>({
    myActivity: false,
    accountManagement: false,
    informationSettings: false
  });

  const navigate = useNavigate();
  profile = profile?.data;

  const toggleSection = (section: string) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const handleKeyDown = (e: React.KeyboardEvent, section: string) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleSection(section);
    }
  };

  const handleItemKeyDown = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.currentTarget.click();
    }
  };

  const handleDeleteAccount = () => {
    toast.promise(
      deleteAccount.makeRequest({ url: ApiConstants?.DeleteAccount }),
      {
        loading: 'Processing...',
        success: (data: any) => data.message,
        error: (error: any) => error.message,
      }
    )
    setVisibleDeleteAccount(false);
  }

  useEffect(() => {
    if (deleteAccount?.status) {
      // toast.success(deleteAccount?.data?.message)
      const modal: any = $('#deleteAccountModal')
      modal.modal('hide')
      $('.modal-backdrop').remove();
      handleLogout(navigate)
    }
  }, [deleteAccount?.status])

  const handleLeaveHouse = () => {
    toast.promise(
      leaveHousue.makeRequest({
        url: ApiConstants?.LeaveHousehold,
        payload: {
          household_id: profile?.hh_member?.household?.id
        },
        type: 'POST'
      }),
      {
        loading: 'Processing...',
        success: (data: any) => data.message,
        error: (error: any) => error.message,
      }
    );
    setVisibleLeaveHH(false);
  }

  useEffect(() => {
    if (leaveHousue?.status) {
      console.log("leaveHousue - - - - >", leaveHousue)
      hhMembers.makeRequest({ url: ApiConstants?.GetHouseholdMembers })
      myProfile.makeRequest({ url: ApiConstants?.Profile, type: 'GET' });
      $('#btn-close-leave-house').click();
    }
  }, [leaveHousue?.status])

  const onRefresh = () => {
    return new Promise(async (resolve: any) => {
      await myProfile.makeRequest({ url: ApiConstants?.Profile, type: ApiTypes?.GET })
      resolve();
    });
  }

  console.log("profile?.hh_member?.member_type: ", profile?.hh_member?.member_type)

  const hasOpportunityPermission = checkPermission(
    profile?.plan_perms,
    PERMISSIONS?.OPPORTUNITY_COST
  );
  const hasReportPermission = checkPermission(
    profile?.plan_perms,
    PERMISSIONS?.REPORTS
  );

  const isPremiumUser = hasAnySubscription(profile);
  const hasHousehold = !!profile?.hh_member;


  return (

    <PageLayout headerName="My Account" onlyTitle={false} className='safe-area-container'>
      <div className='profile-page'>
        <div className='profile-with-name'>
          <div className='profile-with-name-img'>
            <Zoom>
              <ProfileImage src={profile?.profile_pic} size={120} />
            </Zoom>
            {(profile?.is_premium) ? <img className='crown-img' src={'assets/images/crown.svg'} alt="" /> : ''}
          </div>
          <div className='profile-name'>
            <span>{profile?.name}</span>
            <span className='mailid'>{profile?.email}</span>
            {(profile?.is_premium) ? <div className='profile-premium'>(Subscribed)</div> : ''}
          </div>
        </div>

        <div className='profile-options'>

          {/* My Activity Accordion */}
          <div className='accordion-section'>
            <div
              className='accordion-header'
              role="button"
              tabIndex={0}
              onClick={() => toggleSection('myActivity')}
              onKeyDown={(e) => handleKeyDown(e, 'myActivity')}
            >
              <h2 className='option-title'>My Activity</h2>
              <img
                src={chevRght}
                alt=""
                className={`accordion-arrow ${expandedSections.myActivity ? 'expanded' : ''}`}
              />
            </div>

            {expandedSections.myActivity && (
              <ul className='options-list accordion-content'>

                <li className={typeof (profile?.hh_member?.member_type) !== 'undefined' && checkPermission(profile?.plan_perms, PERMISSIONS?.BASIC_CHORES) ? '' : 'pointer-events-none'} style={{ pointerEvents: "auto" }} onClick={() => {
                  !isPremiumUser && toast.error('Please purchase a subscription to access these app features.')
                }}>
                  <a className='cursor-pointer' tabIndex={0} onKeyDown={handleItemKeyDown} onClick={() => { isPremiumUser && (!profile?.hh_member ? toast.error('Please create a household first.') : navigate(Routes?.Chores)) }}>
                    <img src={chores} className='option-icon' />
                    <div className='option-single-rght'>
                      Chores
                      <img className='chev-arw' src={chevRght} alt="" />
                    </div>
                  </a>
                </li>

                <li className={typeof (profile?.hh_member?.member_type) !== 'undefined' && checkPermission(profile?.plan_perms, PERMISSIONS?.EXPENSES) ? '' : 'pointer-events-none'} style={{ pointerEvents: "auto" }} onClick={() => {
                  !isPremiumUser && toast.error('Please purchase a subscription to access these app features.')
                }}>
                  <a className='cursor-pointer' tabIndex={0} onKeyDown={handleItemKeyDown} onClick={() => { isPremiumUser && (!profile?.hh_member ? toast.error('Please create a household first.') : navigate(Routes?.Expenses)) }}>
                    <img src={expense} className='option-icon' />
                    <div className='option-single-rght'>
                      Expenses
                      <img className='chev-arw' src={chevRght} alt="" />
                    </div>
                  </a>
                </li>

                <li className={typeof (profile?.hh_member?.member_type) !== 'undefined' && checkPermission(profile?.plan_perms, PERMISSIONS?.OPPORTUNITY_COST) ? '' : 'pointer-events-none'} style={{ pointerEvents: "auto" }}
                  onClick={(e) => {
                    e.stopPropagation();

                    if (!isPremiumUser) {
                      toast.error('Please purchase a subscription to access these app features.');
                      return;
                    }

                    if (!hasHousehold) {
                      toast.error('Please create a household first.');
                      return;
                    }

                    if (!hasOpportunityPermission) {
                      toast.dismiss();
                      toast.custom((t) => <UpgradeToast t={t} />, {
                        id: "upgrade-toast",
                        duration: 3000,
                      });
                      return;
                    }

                    navigate(Routes?.OpportunityCost);
                  }}>
                  <a className='cursor-pointer' tabIndex={0} onKeyDown={handleItemKeyDown}>
                    <img src={opportunityCost} className='option-icon' />
                    <div className='option-single-rght'>
                      Opportunity Costs
                      <img className='chev-arw' src={chevRght} alt="" />
                    </div>
                  </a>
                </li>

                {/* <li
                  className={!canAccessOpportunity ? 'disabled' : ''}
                  onClick={(e) => {
                    e.stopPropagation();

                    if (!isPremiumUser) {
                      toast.error('Please purchase a subscription to access these app features.');
                      return;
                    }

                    if (!hasHousehold) {
                      toast.error('Please create a household first.');
                      return;
                    }

                    if (!hasOpportunityPermission) {
                      toast.custom(() => <UpgradeToast />);
                      return;
                    }

                    navigate(Routes?.OpportunityCost);
                  }}
                >
                  <div className='menu-item'>
                    <img src={opportunityCost} className='option-icon' />
                    <div className='option-single-rght'>
                      Opportunity Costs
                      <img className='chev-arw' src={chevRght} alt="" />
                    </div>
                  </div>
                </li> */}

                <li className={isPremiumUser && typeof (profile?.hh_member?.member_type) !== 'undefined' ? '' : 'pointer-events-none'} style={{ pointerEvents: "auto" }} onClick={() => {
                  !isPremiumUser && toast.error('Please purchase a subscription to access these app features.')
                }}>
                  <a className='cursor-pointer' tabIndex={0} onKeyDown={handleItemKeyDown}
                    onClick={() => {
                      isPremiumUser && (!profile?.hh_member ? toast.error('Please create a household first.') : navigate(Routes?.Contributions))
                    }}>
                    <img src={contribution} className='option-icon' />
                    <div className='option-single-rght'>
                      Contributions
                      <img className='chev-arw' src={chevRght} alt="" />
                    </div>
                  </a>
                </li>

                <li className={typeof (profile?.hh_member?.member_type) !== 'undefined' && checkPermission(profile?.plan_perms, PERMISSIONS?.PAYEMTS) ? '' : 'pointer-events-none'} style={{ pointerEvents: "auto" }}
                  onClick={() => {
                    !isPremiumUser && toast.error('Please purchase a subscription to access these app features.')
                  }}>
                  <a className='cursor-pointer' tabIndex={0} onKeyDown={handleItemKeyDown}
                    onClick={() => {
                      (profile?.is_premium || profile?.is_household_premium) && (!profile?.hh_member ? toast.error('Please create a household first.') : navigate(Routes?.Payment))
                    }}>
                    <img src={payment} className='option-icon' />
                    <div className='option-single-rght'>
                      Payments
                      <img className='chev-arw' src={chevRght} alt="" />
                    </div>
                  </a>
                </li>

                <li
                  className={typeof (profile?.hh_member?.member_type) !== 'undefined' && checkPermission(profile?.plan_perms, PERMISSIONS?.REPORTS) ? '' : 'pointer-events-none'} style={{ pointerEvents: "auto" }}
                  onClick={(e) => {
                    e.stopPropagation();

                    if (!isPremiumUser) {
                      toast.error('Please purchase a subscription to access these app features.');
                      return;
                    }

                    if (!hasHousehold) {
                      toast.error('Please create a household first.');
                      return;
                    }

                    if (!hasReportPermission) {
                      toast.dismiss();
                      toast.custom((t) => <UpgradeToast t={t} />, {
                        id: "upgrade-toast",
                        duration: 3000,
                      });
                      return;
                    }

                    navigate(Routes?.Reports);
                  }}>
                  <a className='cursor-pointer' tabIndex={0} onKeyDown={handleItemKeyDown}>
                    <img src={report} className='option-icon' />
                    <div className='option-single-rght'>
                      Reports
                      <img className='chev-arw' src={chevRght} alt="" />
                    </div>
                  </a>
                </li>
              </ul>
            )}
          </div>

          {/* Account Management Accordion */}
          <div className='accordion-section'>
            <div
              className='accordion-header'
              role="button"
              tabIndex={0}
              onClick={() => toggleSection('accountManagement')}
              onKeyDown={(e) => handleKeyDown(e, 'accountManagement')}
            >
              <h2 className='option-title'>Account Management</h2>
              <img
                src={chevRght}
                alt=""
                className={`accordion-arrow ${expandedSections.accountManagement ? 'expanded' : ''}`}
              />
            </div>

            {expandedSections.accountManagement && (
              <ul className='options-list accordion-content'>
                <li>
                  <Link to={`${Routes?.UpdateProfile}`}>
                    <img src={editIcon} className='option-icon' />
                    <div className='option-single-rght'>
                      Edit Profile
                      <img className='chev-arw' src={chevRght} alt="" />
                    </div>
                  </Link>
                </li>

                <li>
                  <Link to={Routes?.ChangePassword}>
                    <img src={newPasswordIcon} className='option-icon' />
                    <div className='option-single-rght'>
                      Set a New Password
                      <img className='chev-arw' src={chevRght} alt="" />
                    </div>
                  </Link>
                </li>

                <li>
                  <Link to={Routes?.NotificationSettings}>
                    <img src={notification} className='option-icon' />
                    <div className='option-single-rght'>
                      Notifications Settings
                      <img className='chev-arw' src={chevRght} alt="" />
                    </div>
                  </Link>
                </li>

                {
                  (((!profile?.hh_member?.member_type) || (profile?.role_type === USER_ROLE_TYPES?.GROUP_ADMIN))) ?
                    <li className={isPremiumUser ? '' : 'pointer-events-none'} style={{ pointerEvents: "auto" }} onClick={() => {
                      !isPremiumUser && toast.error('Please purchase a subscription to access these app features.')
                    }}>
                      <Link to={!isPremiumUser ? '#' : Routes?.ManageHousehold}>
                        <img src={usersIcon} className='option-icon' />
                        <div className='option-single-rght'>
                          Household
                          <img className='chev-arw' src={chevRght} alt="" />
                        </div>
                      </Link>
                    </li>
                    :
                    <li>
                      <a
                        style={{ cursor: "pointer" }} onClick={() => setVisibleLeaveHH(true)}
                      >
                        <img src={usersIcon} className='option-icon' />
                        <div className='option-single-rght'>
                          Leave Current Household
                          <img className='chev-arw' src={chevRght} alt="" />
                        </div>
                      </a>
                    </li>
                }

                <li>
                  {((!profile?.hh_member?.member_type) || (profile?.role_type === USER_ROLE_TYPES?.GROUP_ADMIN)) ?
                    <Link to={Routes?.Subscription}>
                      <img src={dollorIcon} className='option-icon' />
                      <div className='option-single-rght'>
                        My Subscription
                        <img className='chev-arw' src={chevRght} alt="" />
                      </div>
                    </Link>
                    : ""}
                </li>

                <li>
                  <a style={{ cursor: "pointer" }} tabIndex={0} onKeyDown={handleItemKeyDown} onClick={() => setVisibleDeleteAccount(true)}>
                    <img src={binIcon} className='option-icon' />
                    <div className='option-single-rght'>
                      Delete Account
                      <img className='chev-arw' src={chevRght} alt="" />
                    </div>
                  </a>
                </li>
              </ul>
            )}
          </div>

          {/* Information & Settings Accordion */}
          <div className='accordion-section'>
            <div
              className='accordion-header'
              role="button"
              tabIndex={0}
              onClick={() => toggleSection('informationSettings')}
              onKeyDown={(e) => handleKeyDown(e, 'informationSettings')}
            >
              <h2 className='option-title'>Information & Settings</h2>
              <img
                src={chevRght}
                alt=""
                className={`accordion-arrow ${expandedSections.informationSettings ? 'expanded' : ''}`}
              />
            </div>

            {expandedSections.informationSettings && (
              <ul className='options-list accordion-content'>
                <li>
                  <Link to={`${Routes?.CmsPages}about-us#About Us`}>
                    <img src={exclamation} className='option-icon' />
                    <div className='option-single-rght'>
                      About Us
                      <img className='chev-arw' src={chevRght} alt="" />
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to={Routes?.ContactUs}>
                    <img src={callIcon} className='option-icon' />
                    <div className='option-single-rght'>
                      Contact Us
                      <img className='chev-arw' src={chevRght} alt="" />
                    </div>
                  </Link>
                </li>

                <li>
                  <Link to={`${Routes?.Faqs}`}>
                    <img src={questionIcon} className='option-icon' />
                    <div className='option-single-rght'>
                      FAQ's
                      <img className='chev-arw' src={chevRght} alt="" />
                    </div>
                  </Link>
                </li>

                <li>
                  <Link to={`${Routes?.CmsPages}privacy-policy#Privacy Policy`}>
                    <img src={shieldIcon} className='option-icon' />
                    <div className='option-single-rght'>
                      Privacy Policy
                      <img className='chev-arw' src={chevRght} alt="" />
                    </div>
                  </Link>
                </li>

                <li>
                  <Link to={`${Routes?.CmsPages}terms-and-conditions#End User License Agreement`}>
                    <img src={fileIcon} className='option-icon' />
                    <div className='option-single-rght'>
                      End User License Agreement
                      <img className='chev-arw' src={chevRght} alt="" />
                    </div>
                  </Link>
                </li>
                <li>
                  <a style={{ cursor: "pointer" }} tabIndex={0} onKeyDown={handleItemKeyDown} onClick={() => setIsModalOpen(true)}>
                    <img src={logout} className='option-icon' />
                    <div className='option-single-rght'>
                      Log out
                      <img className='chev-arw' src={chevRght} alt="" />
                    </div>
                  </a>
                </li>
              </ul>
            )}
          </div>

        </div>

        {isModalOpen &&
          <Logout handleLogout={() => handleLogout(navigate)} toggleModal={() => setIsModalOpen(false)} />
        }

        {visibleDeleteAccount &&
          <CustomModal title='Are you sure you would like to delete your account?' buttonTxt={'Delete'} onConfirm={handleDeleteAccount} toggleModal={() => setVisibleDeleteAccount(false)} />
        }
        {visibleLeaveHH &&
          <CustomModal title='Are you sure you would like to leave this household?' onConfirm={handleLeaveHouse} toggleModal={() => setVisibleLeaveHH(false)} />
        }

        {/*==== Delete Account Modal Start ====*/}
        <div className="modal fade inner-modal com-modal" id="deleteAccountModal" tabIndex={-1} aria-labelledby="deleteAccountModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-body pt-4 pb-0">
                <p className='com-modal-para mb-2 mt-3'>Are you sure you would like to <br /> delete your account?</p>
              </div>
              <div className='modal-footer border-0 mt-3 justify-content-center'>
                <button type='button' className='com-btn com-btn-gray btn-close-delete-exp-modal' data-bs-dismiss="modal" >Cancel</button>
                <Button type='button' className='com-btn' onClick={handleDeleteAccount} loading={deleteAccount?.loading}>Confirm</Button>
              </div>
            </div>
          </div>
        </div>
        {/*==== Delete Account Modal End ====*/}

        <div className="modal fade inner-modal com-modal" id="leaveHouseModal" tabIndex={-1} aria-labelledby="leaveHouseModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-body pt-4 pb-0">
                <p className='com-modal-para mb-2 mt-3'>Are you sure you would like to <br /> leave this household?</p>
              </div>
              <div className='modal-footer border-0 mt-3 justify-content-center'>
                <button type='button' className='com-btn com-btn-gray' id='btn-close-leave-house' data-bs-dismiss="modal"  >Cancel</button>
                <Button type='button' className='com-btn' onClick={handleLeaveHouse} loading={leaveHousue.loading}>Confirm</Button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </PageLayout >

  )
}

export default Profile